import React from 'react';
import * as mobxReact from 'mobx-react';
import Spinner from '../../../../global/spinner/spinner';
import UploadButton, { FILE_TYPE } from '../upload-button';
import UploadImageS3VM from './upload-image-to-s3.viewmodel';
import UploadImage from './upload-image';
import './upload-image-to-s3.scss';
import { OEToggle } from '../../../../global/oe-toggle/oe-toggle';
import Text from '../../../../global/text/text';
import { FormField } from '../../../../global/form/form-field/form-field';

interface IUploadImageS3Presentation {
    vm: UploadImageS3VM;
    minDimensions?: number;
    dimensions?: number;
    fieldName?: string;
    infoIconText?: string | null;
}

const UploadImageS3Presentation = mobxReact.observer(({
    vm,
    minDimensions = null,
    fieldName,
    dimensions = null,
    infoIconText = null,
}: IUploadImageS3Presentation) => {
    const imageSrc = vm.getImagePreview() || vm.image.assetUrl;
    const imageName = vm.getImageName() || vm.image.title;

    return (
        <>
            {typeof vm?.defaultImage?.showImageByDefault === 'boolean' &&
                <div className='website-custom__checkbox-label m-bottom-16px'>
                    <OEToggle
                        isSelected={vm.showDefaultImage}
                        onClick={vm.toggleShowDefaultImage}
                    />
                    <Text
                        message={vm.showDefaultImage ? vm.defaultImage.defaultLogoToggleLabel : vm.defaultImage.defaultLogoToggleLabelDisabled}
                    />
                </div>
            }
            <FormField label={fieldName} infoIconText={infoIconText}>
                {!!vm.imageDescription &&
                    <div className='image-description'>
                        {vm.imageDescription}
                    </div>
                }
                {vm.isImageUploading ?
                    <Spinner /> : vm.showDefaultImage || !!imageSrc ?
                        <UploadImage
                            imgSrc={imageSrc}
                            imgName={imageName}
                            onChange={e => vm.setImage({file: e.target.files[0], minDimensions: minDimensions, fieldName: fieldName, dimensions: dimensions})}
                            deleteImage={vm.deleteImage}
                            withSVGType={true}
                            defaultImage={vm.defaultImage}
                            showDefaultImage={vm.showDefaultImage}
                        />
                        : <UploadButton
                            uploadedFileType={FILE_TYPE.IMG}
                            onChange={e => vm.setImage({file: e as File, minDimensions: minDimensions, fieldName: fieldName, dimensions: dimensions })}
                            withSVGType={!vm.exceptSVG}
                        />}

                {vm.isImageFormChecked && <span className='oe-form-field__error'>{vm.imageError}</span>}
            </FormField>
        </>
    );
});


export { UploadImageS3Presentation };